import React, { useState } from "react";
import { Route, Routes } from "react-router-dom";
import NotFound from "pages/common/notFound";
import Calendar from "./calendar";
import Room from "./room";
// import style from "css/meeting.module.css";
// import { Button, ConfigProvider } from "antd";
// import { ReactComponent as MeetingNow } from "asset/calendar/meetingNow.svg";
import HotDesking from "pages/hotdesking/HotDesking";

/**
 * 파일명: meeting.js
 * 작성자: 강연승
 * 작성일자: 23.04.12
 * 설명: 일정만들기 router
 */

function Meeting() {
  const [type, setType] = useState("room");
  return (
    <>
      {type === "room" ? (
        <Room setType={(res) => setType(res)} />
      ) : (
        <Calendar setType={(res) => setType(res)} />
      )}
    </>
  );
}

export default Meeting;
